import React, { useState, useEffect } from "react";
import {
  CardTitle,
} from "reactstrap";
import moment from 'moment';
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../../components/Paginationv3";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
// router
import { useLocation } from "react-router-dom";
//service
import leadCollectorService from "../../../../utils/services/leadCollector";
import * as groupService from "../../../../utils/services/group";
import excelService from "../../../../utils/services/excelService";

import CommandButtons from './CommandButtons';
import GuestsList from './GuestsList';
import ModalStandReport from './ModalStandReport';

function LeadCollectorReports(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;
  const foundProducts = props.state.global_user_data.data.foundProducts;

  const [isLoading, setIsLoading] = useState(false);
  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [groups, setGroups] = useState([]);
  const [modalStandReportControl, setModalStandReportControl] = React.useState({
    open: false,
    group: '',
  });
  const [guestsList, setGuestsList] = useState([]);
  // loading
  const [loading, setLoading] = useState(false);
  const [searchControl, setSearchControl] = React.useState({
    total: 0,
  });
  const searchControlRef = React.useRef(searchControl);
  React.useEffect(() => {
    searchControlRef.current = searchControl;
  }, [searchControl]);
  const [currentIndex, setCurrentIndex] = useState(1);
  const currentIndexRef = React.useRef(currentIndex);
  React.useEffect(() => {
    currentIndexRef.current = currentIndex;
    getData();
  }, [currentIndex]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageRef = React.useRef(itemsPerPage);
  React.useEffect(() => {
    itemsPerPageRef.current = itemsPerPage;
    getData();
  }, [itemsPerPage]);

  useEffect(() => {
    getData();
    getGroupsFunc();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      setLoading(true);
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      let _offset = (currentIndexRef.current - 1) * itemsPerPageRef.current;
      let _guests = await leadCollectorService.getAllRegistersByEventId(
        eventId,
        itemsPerPageRef.current,
        _offset,
      );

      setGuestsList(_guests.data);
      setSearchControl({ ...searchControlRef.current, total: _guests.count });

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoading(false);
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [searchControl, itemsPerPage, currentIndex, guestsList]);

  const getGroupsFunc = React.useCallback(async () => {
    try {
      let _groups = await groupService.getGroups({
        jwt: props.state.global_user_data.data.token,
        eventId: eventId,
        offset: 1,
        limit: 0,
        search: "",
      });
      setGroups(_groups.findOneGroupData.data);
    } catch (error) {
      console.log('Error getGroupsFunc', error);
    }
  }, [groups]);

  const getAllRegistersByEventId = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Buscando' });

      let _columnInfo = getColumnInfo();
      let _json = await getRegistersList();

      await excelService.getXlsxFromObjectArray({
        columnInfo: _columnInfo,
        array: _json,
        fileName: `Relatório_Coletor_${moment().format(
          "DD/MM/YYYY-HH:mm"
        )}.xlsx`,
        isWeb: true,
      });
    } catch (error) {
      console.log('Error getAllRegistersByEventId', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function getColumnInfo() {
      return [
        {
          columnName: "userName",
          text: `Nome Usuário`,
          width: 40,
        },
        {
          columnName: "userEmail",
          text: `Email Usuário`,
          width: 40,
        },
        {
          columnName: "eventId",
          text: `ID Evento`,
          width: 40,
        },
        {
          columnName: "eventName",
          text: `Nome Evento`,
          width: 40,
        },
        {
          columnName: "scheduleName",
          text: `Nome Programação`,
          width: 40,
        },
        {
          columnName: "organization",
          text: `Organização`,
          width: 40,
        },
        {
          columnName: "guestId",
          text: `ID Participante`,
          width: 40,
        },
        {
          columnName: "guestName",
          text: `Nome Participante`,
          width: 40,
        },
        {
          columnName: "guestEmail",
          text: `Email Participante`,
          width: 60,
        },
        {
          columnName: "guestPhone",
          text: `Telefone Participante`,
          width: 40,
        },
        {
          columnName: "guestCompany",
          text: `Empresa Participante`,
          width: 40,
        },
        {
          columnName: "guestPosition",
          text: `Cargo Participante`,
          width: 40,
        },
        {
          columnName: "stars",
          text: 'Classificação',
          width: 20,
        },
        {
          columnName: "note",
          text: 'Observação',
          width: 60,
        },
        {
          columnName: "date",
          text: 'Data',
          width: 60,
        },
      ];
    }

    async function getRegistersList() {
      let _return = [];

      let _hasMore = true;
      let _offset = 0;
      do {
        let _data = await leadCollectorService.getAllRegistersByEventId(eventId, 200, _offset);
        _offset += 200;
        if (_data.count < _offset) {
          _hasMore = false;
        }

        _return = [..._return, ..._data.data];
        let _progress = ((_offset / _data.count) * 100).toFixed(0);
        setLoadingControl({
          ...loadingControl,
          open: true,
          message: `Buscando ${_progress > 100 ? 100 : _progress}%`,
        });
      } while (_hasMore);

      return _return;
    }
  }, [eventId]);

  const extractReportByGroup = React.useCallback(async () => {
    try {
      setLoadingControl({
        ...loadingControl,
        open: true,
        message: 'Buscando',
      });

      let _columnInfo = getColumnInfo();
      let _json = await getJsonData();

      await excelService.getXlsxFromObjectArray({
        columnInfo: _columnInfo,
        array: _json,
        fileName: `Relatório_Coletor_${modalStandReportControl.group.label}_${moment().format(
          "DD/MM/YYYY-HH:mm"
        )}.xlsx`,
        isWeb: true,
      });

      setModalStandReportControl({ ...modalStandReportControl, open: false });
    } catch (error) {
      console.log("Error extractReportByGroup", error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function getColumnInfo() {
      try {
        return [
          {
            columnName: "id",
            text: "ID",
            width: 60,
          },
          {
            columnName: "userName",
            text: `Nome Usuário`,
            width: 40,
          },
          {
            columnName: "userEmail",
            text: `Email Usuário`,
            width: 40,
          },
          {
            columnName: "name",
            text: 'Nome',
            width: 40,
          },
          {
            columnName: "email",
            text: 'Email',
            width: 60,
          },
          {
            columnName: "phone",
            text: 'Telefone',
            width: 40,
          },
          {
            columnName: "company",
            text: 'Empresa',
            width: 40,
          },
          {
            columnName: "position",
            text: 'Cargo',
            width: 40,
          },
          {
            columnName: "stars",
            text: 'Classificação',
            width: 20,
          },
          {
            columnName: "note",
            text: 'Observação',
            width: 60,
          },
          {
            columnName: "date",
            text: 'Data',
            width: 60,
          },
        ];
      } catch (error) {
        console.log("Error getColumnInfo", error);
        throw error;
      }
    }

    async function getJsonData() {
      try {
        const _organization = await leadCollectorService.getOrganization(modalStandReportControl.group.label);

        const _schedule = await leadCollectorService.getSchedule(_organization.id, eventId);

        let _array = [];

        let _hasMore = true;
        let _offset = 0;
        do {
          let _data = await leadCollectorService.getGuestsWithClassificationBySchedule(_schedule.id, 200, _offset);
          _offset += 200;
          if (_data.count < _offset) {
            _hasMore = false;
          }

          _array = [..._array, ..._data.data];
          let _progress = ((_offset / _data.count) * 100).toFixed(0);
          setLoadingControl({
            ...loadingControl,
            open: true,
            message: `Buscando ${_progress > 100 ? 100 : _progress}%`,
          });
        } while (_hasMore);

        return _array;
      } catch (error) {
        console.log("Error getJsonData", error);
        throw error;
      }
    }
  }, [modalStandReportControl]);

  return (
    <div>
      <CardTitle>Relatório Geral de Participantes</CardTitle>
      <CommandButtons
        getAllRegistersByEventId={getAllRegistersByEventId}
        groups={groups}
        modalStandReportControl={modalStandReportControl}
        setModalStandReportControl={setModalStandReportControl}
      />
      <GuestsList
        guestsList={guestsList}
        loading={loading}
      />
      <Pagination
        data={guestsList}
        search={searchControl.search}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={searchControl.total}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />

      <ModalStandReport
        modalStandReportControl={modalStandReportControl}
        setModalStandReportControl={setModalStandReportControl}
        groups={groups}
        extractReportByGroup={extractReportByGroup}
      />
      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(LeadCollectorReports);
